<script setup>
import { ref, onBeforeUnmount, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useRouter } from 'vue-router';
import { login } from '@/api';

import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];


const email = ref('');
const password = ref('');
const error = ref('');
const router = useRouter();

const store = useStore();
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});

const handleLogin = async () => {
  try {
    error.value = '';
    if (!email.value?.trim() || !password.value?.trim()) {
      error.value = 'Correo y contraseña son obligatorios';
      return
    }
    const response = await login(email.value.trim(), password.value);

    localStorage.setItem("token", response.token);
    localStorage.setItem("refreshToken", response.refreshToken);
    localStorage.setItem("user", JSON.stringify(response.usuario || response.user));

    router.push("/dashboard-default");
  } catch (err) {
    // login() lanza string o error con response; prioriza message
    if (typeof err === 'string') {
      error.value = err;
    } else if (err?.response?.status === 429) {
      error.value = err.response?.data?.message || 'Demasiados intentos. Intente nuevamente en unos minutos.';
    } else {
      error.value = err?.response?.data?.message || err?.message || "Error al iniciar sesión";
    }
  }
};
</script>
<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow" v-bind:darkMode="true"
          isBtn="bg-gradient-success" />
      </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Iniciar</h4>
                  <p class="mb-0">Ingresa tu correo y clave para ingresar al sistema</p>
                </div>
                <div class="card-body">
                  <form @submit.prevent="handleLogin" role="form">
                    <div class="mb-3">
                      <argon-input id="email" type="email" placeholder="Email" v-model="email" size="lg" required />
                    </div>
                    <div class="mb-3">
                      <argon-input id="password" type="password" placeholder="Password" v-model="password" size="lg" required />
                    </div>

                    <div class="text-center">
                      <argon-button class="mt-4" variant="gradient" color="success" fullWidth size="lg" type="submit">
                        Ingresar
                      </argon-button>
                    </div>
                    <p v-if="error" class="text-danger mt-2">{{ error }}</p>
                  </form>
                </div>

              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column">
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                :style="{ backgroundImage: `url(${require('@/assets/img/login.webp')})`, backgroundSize: 'cover' }">
                <span class="mask bg-gradient-success opacity-6"></span>
                <h4 class="mt-5 text-white font-weight-bolder position-relative">
                  "La disciplina es el puente entre las metas y los resultados"
                </h4>
                <p class="text-white position-relative">
                  Administra tu gimnasio con precisión: desde el control de accesos hasta el seguimiento del progreso de
                  tus socios, todo en un solo lugar..
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
